export const CountryPhoneMetadata = [
  {'country': 'Afghanistan', 'phonePrefix': '+93', 'iso': 'af'}, {
    'country': 'Albania',
    'phonePrefix': '+355',
    'iso': 'al'
  }, {'country': 'Algeria', 'phonePrefix': '+213', 'iso': 'dz'},
  // {
  //   'country': 'American Samoa',
  //   'phonePrefix': '+1',
  //   'iso': 'as'
  // },
  {'country': 'Andorra', 'phonePrefix': '+376', 'iso': 'ad'}, {
    'country': 'Angola',
    'phonePrefix': '+244',
    'iso': 'ao'
  },
  // {'country': 'Anguilla', 'phonePrefix': '+1', 'iso': 'ai'}, {
  //   'country': 'Antarctica',
  //   'phonePrefix': '+672',
  //   'iso': 'aq'
  // },
  {'country': 'Antigua and Barbuda', 'phonePrefix': '+1', 'iso': 'ag'}, {
    'country': 'Argentina',
    'phonePrefix': '+54',
    'iso': 'ar'
  }, {'country': 'Armenia', 'phonePrefix': '+374', 'iso': 'am'}, {
    'country': 'Aruba',
    'phonePrefix': '+297',
    'iso': 'aw'
  }, {'country': 'Australia', 'phonePrefix': '+61', 'iso': 'au'}, {
    'country': 'Austria',
    'phonePrefix': '+43',
    'iso': 'at'
  }, {'country': 'Azerbaijan', 'phonePrefix': '+994', 'iso': 'az'}, {
    'country': 'Bahamas',
    'phonePrefix': '+1',
    'iso': 'bs'
  }, {'country': 'Bahrain', 'phonePrefix': '+973', 'iso': 'bh'}, {
    'country': 'Bangladesh',
    'phonePrefix': '+880',
    'iso': 'bd'
  }, {'country': 'Barbados', 'phonePrefix': '+1', 'iso': 'bb'}, {
    'country': 'Belarus',
    'phonePrefix': '+375',
    'iso': 'by'
  }, {'country': 'Belgium', 'phonePrefix': '+32', 'iso': 'be'}, {
    'country': 'Belize',
    'phonePrefix': '+501',
    'iso': 'bz'
  }, {'country': 'Benin', 'phonePrefix': '+229', 'iso': 'bj'},
  // {'country': 'Bermuda', 'phonePrefix': '+1', 'iso': 'bm'},
  {
    'country': 'Bhutan',
    'phonePrefix': '+975',
    'iso': 'bt'
  }, {'country': 'Bolivia', 'phonePrefix': '+591', 'iso': 'bo'}, {
    'country': 'Bosnia and Herzegovina',
    'phonePrefix': '+387',
    'iso': 'ba'
  }, {'country': 'Botswana', 'phonePrefix': '+267', 'iso': 'bw'}, {
    'country': 'Brazil',
    'phonePrefix': '+55',
    'iso': 'br'
  },
  // {'country': 'British Indian Ocean Territory', 'phonePrefix': '+246', 'iso': 'io'}, {
  //   'country': 'British Virgin Islands',
  //   'phonePrefix': '+1',
  //   'iso': 'vg'
  // },
  {'country': 'Brunei', 'phonePrefix': '+673', 'iso': 'bn'}, {
    'country': 'Bulgaria',
    'phonePrefix': '+359',
    'iso': 'bg'
  }, {'country': 'Burkina Faso', 'phonePrefix': '+226', 'iso': 'bf'}, {
    'country': 'Burundi',
    'phonePrefix': '+257',
    'iso': 'bi'
  }, {'country': 'Cambodia', 'phonePrefix': '+855', 'iso': 'kh'}, {
    'country': 'Cameroon',
    'phonePrefix': '+237',
    'iso': 'cm'
  }, {'country': 'Canada', 'phonePrefix': '+1', 'iso': 'ca'}, {
    'country': 'Cape Verde',
    'phonePrefix': '+238',
    'iso': 'cv'
  },
  // {'country': 'Cayman Islands', 'phonePrefix': '+1', 'iso': 'ky'},
  {
    'country': 'Central African Republic',
    'phonePrefix': '+236',
    'iso': 'cf'
  }, {'country': 'Chad', 'phonePrefix': '+235', 'iso': 'td'}, {'country': 'Chile', 'phonePrefix': '+56', 'iso': 'cl'}, {
    'country': 'China',
    'phonePrefix': '+86',
    'iso': 'cn'
  },
  // {'country': 'Christmas Island', 'phonePrefix': '+61', 'iso': 'cx'}, {
  //   'country': 'Cocos Islands',
  //   'phonePrefix': '+61',
  //   'iso': 'cc'
  // },
  {'country': 'Colombia', 'phonePrefix': '+57', 'iso': 'co'}, {
    'country': 'Comoros',
    'phonePrefix': '+269',
    'iso': 'km'
  },
  // {'country': 'Cook Islands', 'phonePrefix': '+682', 'iso': 'ck'},
  {
    'country': 'Costa Rica',
    'phonePrefix': '+506',
    'iso': 'cr'
  }, {'country': 'Croatia', 'phonePrefix': '+385', 'iso': 'hr'}, {
    'country': 'Cuba',
    'phonePrefix': '+53',
    'iso': 'cu'
  }, {'country': 'Curacao', 'phonePrefix': '+599', 'iso': 'cw'}, {
    'country': 'Cyprus',
    'phonePrefix': '+357',
    'iso': 'cy'
  }, {'country': 'Czech Republic', 'phonePrefix': '+420', 'iso': 'cz'}, {
    'country': 'Democratic Republic of the Congo',
    'phonePrefix': '+243',
    'iso': 'cd'
  }, {'country': 'Denmark', 'phonePrefix': '+45', 'iso': 'dk'}, {
    'country': 'Djibouti',
    'phonePrefix': '+253',
    'iso': 'dj'
  }, {'country': 'Dominica', 'phonePrefix': '+1-767', 'iso': 'dm'}, {
    'country': 'Dominican Republic',
    'phonePrefix': '+1',
    'iso': 'do'
  }, {'country': 'East Timor', 'phonePrefix': '+670', 'iso': 'tl'}, {
    'country': 'Ecuador',
    'phonePrefix': '+593',
    'iso': 'ec'
  }, {'country': 'Egypt', 'phonePrefix': '+20', 'iso': 'eg'}, {
    'country': 'El Salvador',
    'phonePrefix': '+503',
    'iso': 'sv'
  }, {'country': 'Equatorial Guinea', 'phonePrefix': '+240', 'iso': 'gq'}, {
    'country': 'Eritrea',
    'phonePrefix': '+291',
    'iso': 'er'
  }, {'country': 'Estonia', 'phonePrefix': '+372', 'iso': 'ee'}, {
    'country': 'Ethiopia',
    'phonePrefix': '+251',
    'iso': 'et'
  },
  // {'country': 'Falkland Islands', 'phonePrefix': '+500', 'iso': 'fk'},
  {
    'country': 'Faroe Islands',
    'phonePrefix': '+298',
    'iso': 'fo'
  }, {'country': 'Fiji', 'phonePrefix': '+679', 'iso': 'fj'}, {
    'country': 'Finland',
    'phonePrefix': '+358',
    'iso': 'fi'
  }, {'country': 'France', 'phonePrefix': '+33', 'iso': 'fr'},
  // {
  //   'country': 'French Polynesia',
  //   'phonePrefix': '+689',
  //   'iso': 'pf'
  // },
  {'country': 'Gabon', 'phonePrefix': '+241', 'iso': 'ga'}, {
    'country': 'Gambia',
    'phonePrefix': '+220',
    'iso': 'gm'
  }, {'country': 'Georgia', 'phonePrefix': '+995', 'iso': 'ge'}, {
    'country': 'Germany',
    'phonePrefix': '+49',
    'iso': 'de'
  }, {'country': 'Ghana', 'phonePrefix': '+233', 'iso': 'gh'},
  // {
  //   'country': 'Gibraltar',
  //   'phonePrefix': '+350',
  //   'iso': 'gi'
  // },
  {'country': 'Greece', 'phonePrefix': '+30', 'iso': 'gr'}, {
    'country': 'Greenland',
    'phonePrefix': '+299',
    'iso': 'gl'
  }, {'country': 'Grenada', 'phonePrefix': '+1-473', 'iso': 'gd'}, {
    'country': 'Guam',
    'phonePrefix': '+1',
    'iso': 'gu'
  }, {'country': 'Guatemala', 'phonePrefix': '+502', 'iso': 'gt'},
  // {
  //   'country': 'Guernsey',
  //   'phonePrefix': '+44',
  //   'iso': 'gg'
  // },
  {'country': 'Guinea', 'phonePrefix': '+224', 'iso': 'gn'}, {
    'country': 'Guinea-Bissau',
    'phonePrefix': '+245',
    'iso': 'gw'
  }, {'country': 'Guyana', 'phonePrefix': '+592', 'iso': 'gy'}, {
    'country': 'Haiti',
    'phonePrefix': '+509',
    'iso': 'ht'
  }, {'country': 'Honduras', 'phonePrefix': '+504', 'iso': 'hn'}, {
    'country': 'Hong Kong',
    'phonePrefix': '+852',
    'iso': 'hk'
  }, {'country': 'Hungary', 'phonePrefix': '+36', 'iso': 'hu'}, {
    'country': 'Iceland',
    'phonePrefix': '+354',
    'iso': 'is'
  }, {'country': 'India', 'phonePrefix': '+91', 'iso': 'in'}, {'country': 'Indonesia', 'phonePrefix': '+62', 'iso': 'id'}, {
    'country': 'Iran',
    'phonePrefix': '+98',
    'iso': 'ir'
  }, {'country': 'Iraq', 'phonePrefix': '+964', 'iso': 'iq'}, {
    'country': 'Ireland',
    'phonePrefix': '+353',
    'iso': 'ie'
  },
  // {'country': 'Isle of Man', 'phonePrefix': '+44', 'iso': 'im'},
  {
    'country': 'Israel',
    'phonePrefix': '+972',
    'iso': 'il'
  }, {'country': 'Italy', 'phonePrefix': '+39', 'iso': 'it'},
  // {
  //   'country': 'Ivory Coast',
  //   'phonePrefix': '+225',
  //   'iso': 'ci'
  // },
  {'country': 'Jamaica', 'phonePrefix': '+1', 'iso': 'jm'},
  {'country': 'Japan', 'phonePrefix': '+81', 'iso': 'jp'},
  // {
  //   'country': 'Jersey',
  //   'phonePrefix': '+44',
  //   'iso': 'je'
  // },
  {'country': 'Jordan', 'phonePrefix': '+962', 'iso': 'jo'}, {
    'country': 'Kazakhstan',
    'phonePrefix': '+7',
    'iso': 'kz'
  }, {'country': 'Kenya', 'phonePrefix': '+254', 'iso': 'ke'}, {
    'country': 'Kiribati',
    'phonePrefix': '+686',
    'iso': 'ki'
  }, {'country': 'Kosovo', 'phonePrefix': '+383', 'iso': 'xk'}, {
    'country': 'Kuwait',
    'phonePrefix': '+965',
    'iso': 'kw'
  }, {'country': 'Kyrgyzstan', 'phonePrefix': '+996', 'iso': 'kg'}, {
    'country': 'Laos',
    'phonePrefix': '+856',
    'iso': 'la'
  }, {'country': 'Latvia', 'phonePrefix': '+371', 'iso': 'lv'}, {
    'country': 'Lebanon',
    'phonePrefix': '+961',
    'iso': 'lb'
  }, {'country': 'Lesotho', 'phonePrefix': '+266', 'iso': 'ls'}, {
    'country': 'Liberia',
    'phonePrefix': '+231',
    'iso': 'lr'
  }, {'country': 'Libya', 'phonePrefix': '+218', 'iso': 'ly'}, {
    'country': 'Liechtenstein',
    'phonePrefix': '+423',
    'iso': 'li'
  }, {'country': 'Lithuania', 'phonePrefix': '+370', 'iso': 'lt'}, {
    'country': 'Luxembourg',
    'phonePrefix': '+352',
    'iso': 'lu'
  }, {'country': 'Macau', 'phonePrefix': '+853', 'iso': 'mo'}, {
    'country': 'Macedonia',
    'phonePrefix': '+389',
    'iso': 'mk'
  }, {'country': 'Madagascar', 'phonePrefix': '+261', 'iso': 'mg'}, {
    'country': 'Malawi',
    'phonePrefix': '+265',
    'iso': 'mw'
  }, {'country': 'Malaysia', 'phonePrefix': '+60', 'iso': 'my'}, {
    'country': 'Maldives',
    'phonePrefix': '+960',
    'iso': 'mv'
  }, {'country': 'Mali', 'phonePrefix': '+223', 'iso': 'ml'}, {
    'country': 'Malta',
    'phonePrefix': '+356',
    'iso': 'mt'
  }, {'country': 'Marshall Islands', 'phonePrefix': '+692', 'iso': 'mh'}, {
    'country': 'Mauritania',
    'phonePrefix': '+222',
    'iso': 'mr'
  }, {'country': 'Mauritius', 'phonePrefix': '+230', 'iso': 'mu'},
  // {
  //   'country': 'Mayotte',
  //   'phonePrefix': '+262',
  //   'iso': 'yt'
  // },
  // },
  {'country': 'Mexico', 'phonePrefix': '+52', 'iso': 'mx'}, {
    'country': 'Micronesia',
    'phonePrefix': '+691',
    'iso': 'fm'
  }, {'country': 'Moldova', 'phonePrefix': '+373', 'iso': 'md'}, {
    'country': 'Monaco',
    'phonePrefix': '+377',
    'iso': 'mc'
  }, {'country': 'Mongolia', 'phonePrefix': '+976', 'iso': 'mn'}, {
    'country': 'Montenegro',
    'phonePrefix': '+382',
    'iso': 'me'
  },
  // {'country': 'Montserrat', 'phonePrefix': '+1', 'iso': 'ms'},
  {
    'country': 'Morocco',
    'phonePrefix': '+212',
    'iso': 'ma'
  }, {'country': 'Mozambique', 'phonePrefix': '+258', 'iso': 'mz'}, {
    'country': 'Myanmar',
    'phonePrefix': '+95',
    'iso': 'mm'
  }, {'country': 'Namibia', 'phonePrefix': '+264', 'iso': 'na'}, {
    'country': 'Nauru',
    'phonePrefix': '+674',
    'iso': 'nr'
  }, {'country': 'Nepal', 'phonePrefix': '+977', 'iso': 'np'}, {
    'country': 'Netherlands',
    'phonePrefix': '+31',
    'iso': 'nl'
  },
  // {'country': 'Netherlands Antilles', 'phonePrefix': '+599', 'iso': 'an'},
  {
    'country': 'New Caledonia',
    'phonePrefix': '+687',
    'iso': 'nc'
  }, {'country': 'New Zealand', 'phonePrefix': '+64', 'iso': 'nz'}, {
    'country': 'Nicaragua',
    'phonePrefix': '+505',
    'iso': 'ni'
  }, {'country': 'Niger', 'phonePrefix': '+227', 'iso': 'ne'}, {'country': 'Nigeria', 'phonePrefix': '+234', 'iso': 'ng'}, {
    'country': 'Niue',
    'phonePrefix': '+683',
    'iso': 'nu'
  }, {'country': 'North Korea', 'phonePrefix': '+850', 'iso': 'kp'}, {
    'country': 'Northern Mariana Islands',
    'phonePrefix': '+1-670',
    'iso': 'mp'
  }, {'country': 'Norway', 'phonePrefix': '+47', 'iso': 'no'}, {
    'country': 'Oman',
    'phonePrefix': '+968',
    'iso': 'om'
  }, {'country': 'Pakistan', 'phonePrefix': '+92', 'iso': 'pk'}, {
    'country': 'Palau',
    'phonePrefix': '+680',
    'iso': 'pw'
  }, {'country': 'Palestine', 'phonePrefix': '+970', 'iso': 'ps'}, {
    'country': 'Panama',
    'phonePrefix': '+507',
    'iso': 'pa'
  }, {'country': 'Papua New Guinea', 'phonePrefix': '+675', 'iso': 'pg'}, {
    'country': 'Paraguay',
    'phonePrefix': '+595',
    'iso': 'py'
  }, {'country': 'Peru', 'phonePrefix': '+51', 'iso': 'pe'}, {
    'country': 'Philippines',
    'phonePrefix': '+63',
    'iso': 'ph'
  },
  // {'country': 'Pitcairn', 'phonePrefix': '+64', 'iso': 'pn'},
  {
    'country': 'Poland',
    'phonePrefix': '+48',
    'iso': 'pl'
  }, {'country': 'Portugal', 'phonePrefix': '+351', 'iso': 'pt'}, {
    'country': 'Puerto Rico',
    'phonePrefix': '+1',
    'iso': 'pr'
  }, {'country': 'Qatar', 'phonePrefix': '+974', 'iso': 'qa'}, {
    'country': 'Republic of the Congo',
    'phonePrefix': '+242',
    'iso': 'cg'
  },
  // {'country': 'Reunion', 'phonePrefix': '+262', 'iso': 're'},
  {
    'country': 'Romania',
    'phonePrefix': '+40',
    'iso': 'ro'
  }, {'country': 'Russia', 'phonePrefix': '+7', 'iso': 'ru'}, {
    'country': 'Rwanda',
    'phonePrefix': '+250',
    'iso': 'rw'
  },
  // {'country': 'Saint Barthelemy', 'phonePrefix': '+590', 'iso': 'bl'},
  // {
  //   'country': 'Saint Helena',
  //   'phonePrefix': '+290',
  //   'iso': 'sh'
  // },
  {'country': 'Saint Kitts and Nevis', 'phonePrefix': '+1-869', 'iso': 'kn'}, {
    'country': 'Saint Lucia',
    'phonePrefix': '+1',
    'iso': 'lc'
  }, {'country': 'Saint Martin', 'phonePrefix': '+590', 'iso': 'mf'},
  // {
  //   'country': 'Saint Pierre and Miquelon',
  //   'phonePrefix': '+508',
  //   'iso': 'pm'
  // },
  {'country': 'Saint Vincent and the Grenadines', 'phonePrefix': '+1', 'iso': 'vc'}, {
    'country': 'Samoa',
    'phonePrefix': '+685',
    'iso': 'ws'
  }, {'country': 'San Marino', 'phonePrefix': '+378', 'iso': 'sm'}, {
    'country': 'Sao Tome and Principe',
    'phonePrefix': '+239',
    'iso': 'st'
  }, {'country': 'Saudi Arabia', 'phonePrefix': '+966', 'iso': 'sa'}, {
    'country': 'Senegal',
    'phonePrefix': '+221',
    'iso': 'sn'
  }, {'country': 'Serbia', 'phonePrefix': '+381', 'iso': 'rs'}, {
    'country': 'Seychelles',
    'phonePrefix': '+248',
    'iso': 'sc'
  }, {'country': 'Sierra Leone', 'phonePrefix': '+232', 'iso': 'sl'}, {
    'country': 'Singapore',
    'phonePrefix': '+65',
    'iso': 'sg'
  },
  // {'country': 'Sint Maarten', 'phonePrefix': '+1', 'iso': 'sx'},
  {
    'country': 'Slovakia',
    'phonePrefix': '+421',
    'iso': 'sk'
  }, {'country': 'Slovenia', 'phonePrefix': '+386', 'iso': 'si'}, {
    'country': 'Solomon Islands',
    'phonePrefix': '+677',
    'iso': 'sb'
  }, {'country': 'Somalia', 'phonePrefix': '+252', 'iso': 'so'}, {
    'country': 'South Africa',
    'phonePrefix': '+27',
    'iso': 'za'
  }, {'country': 'South Korea', 'phonePrefix': '+82', 'iso': 'kr'}, {
    'country': 'South Sudan',
    'phonePrefix': '+211',
    'iso': 'ss'
  }, {'country': 'Spain', 'phonePrefix': '+34', 'iso': 'es'}, {
    'country': 'Sri Lanka',
    'phonePrefix': '+94',
    'iso': 'lk'
  }, {'country': 'Sudan', 'phonePrefix': '+249', 'iso': 'sd'}, {
    'country': 'Suriname',
    'phonePrefix': '+597',
    'iso': 'sr'
  },
  // {'country': 'Svalbard and Jan Mayen', 'phonePrefix': '+47', 'iso': 'sj'},
  {
    'country': 'Swaziland',
    'phonePrefix': '+268',
    'iso': 'sz'
  }, {'country': 'Sweden', 'phonePrefix': '+46', 'iso': 'se'}, {
    'country': 'Switzerland',
    'phonePrefix': '+41',
    'iso': 'ch'
  }, {'country': 'Syria', 'phonePrefix': '+963', 'iso': 'sy'}, {
    'country': 'Taiwan',
    'phonePrefix': '+886',
    'iso': 'tw'
  }, {'country': 'Tajikistan', 'phonePrefix': '+992', 'iso': 'tj'}, {
    'country': 'Tanzania',
    'phonePrefix': '+255',
    'iso': 'tz'
  }, {'country': 'Thailand', 'phonePrefix': '+66', 'iso': 'th'}, {
    'country': 'Togo',
    'phonePrefix': '+228',
    'iso': 'tg'
  },
  // {'country': 'Tokelau', 'phonePrefix': '+690', 'iso': 'tk'},
  {
    'country': 'Tonga',
    'phonePrefix': '+676',
    'iso': 'to'
  }, {'country': 'Trinidad and Tobago', 'phonePrefix': '+1', 'iso': 'tt'}, {
    'country': 'Tunisia',
    'phonePrefix': '+216',
    'iso': 'tn'
  }, {'country': 'Turkey', 'phonePrefix': '+90', 'iso': 'tr'}, {
    'country': 'Turkmenistan',
    'phonePrefix': '+993',
    'iso': 'tm'
  },
  // {'country': 'Turks and Caicos Islands', 'phonePrefix': '+1-649', 'iso': 'tc'},
  {
    'country': 'Tuvalu',
    'phonePrefix': '+688',
    'iso': 'tv'
  },
  // {'country': 'US Virgin Islands', 'phonePrefix': '+1', 'iso': 'vi', 'hide': true},
  {
    'country': 'Uganda',
    'phonePrefix': '+256',
    'iso': 'ug'
  }, {'country': 'Ukraine', 'phonePrefix': '+380', 'iso': 'ua'}, {
    'country': 'United Arab Emirates',
    'phonePrefix': '+971',
    'iso': 'ae'
  }, {'country': 'United Kingdom', 'phonePrefix': '+44', 'iso': 'gb'}, {
    'country': 'United States',
    'phonePrefix': '+1',
    'iso': 'us',
    'nested': [{
      'country': 'US Virgin Islands',
      'phonePrefix': '+1',
      'iso': 'vi'
    }]
  }, {'country': 'Uruguay', 'phonePrefix': '+598', 'iso': 'uy'}, {
    'country': 'Uzbekistan',
    'phonePrefix': '+998',
    'iso': 'uz'
  }, {'country': 'Vanuatu', 'phonePrefix': '+678', 'iso': 'vu'}, {
    'country': 'Vatican',
    'phonePrefix': '+379',
    'iso': 'va'
  }, {'country': 'Venezuela', 'phonePrefix': '+58', 'iso': 've'}, {
    'country': 'Vietnam',
    'phonePrefix': '+84',
    'iso': 'vn'
  },
  // {'country': 'Wallis and Futuna', 'phonePrefix': '+681', 'iso': 'wf'},
  // {
  //   'country': 'Western Sahara',
  //   'phonePrefix': '+212',
  //   'iso': 'eh'
  // },
  {'country': 'Yemen', 'phonePrefix': '+967', 'iso': 'ye'}, {
    'country': 'Zambia',
    'phonePrefix': '+260',
    'iso': 'zm'
  }, {'country': 'Zimbabwe', 'phonePrefix': '+263', 'iso': 'zw'}]
